"use strict";

exports.__esModule = true;
exports.default = void 0;

var _schema = _interopRequireDefault(require("../conditionId/schema"));

var _schema2 = _interopRequireDefault(require("../conditionConsequenceId/schema"));

var _schema3 = _interopRequireDefault(require("../condition/schema"));

var _schema4 = _interopRequireDefault(require("../damage/schema"));

var _schema5 = _interopRequireDefault(require("../work/schema"));

var _schema6 = _interopRequireDefault(require("../task/schema"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  "type": "object",
  "properties": {
    "documentType": {
      "type": "string",
      "default": "building"
    },
    "createdAt": {
      "type": "string"
    },
    "updatedAt": {
      "type": "string"
    },
    "uniqueId": {
      "type": "string"
    },
    "title": {
      "type": "string"
    },
    "content": {
      "type": "object",
      "properties": {
        "registerType": {
          "type": "string",
          "enum": ["single", "collection"],
          "enumNames": ["Enkeltobjekt", "Samling"],
          "default": "tk0"
        },
        "objectId": {
          "type": "string"
        },
        "conditionId": _schema.default,
        "conditionConsequenceId": _schema2.default,
        "title": {
          "type": "string"
        },
        "damage": {
          "type": "array",
          "items": _schema4.default
        },
        "condition": {
          "type": "array",
          "items": _schema3.default
        },
        "work": {
          "type": "array",
          "items": _schema5.default
        },
        "task": {
          "type": "array",
          "items": _schema6.default
        },
        "media": {
          "type": "array",
          "items": {
            "type": "image"
          }
        }
      }
    }
  }
};
exports.default = _default;
module.exports = exports.default;